<div class="page-header">
  <div>
    <h1>Staff</h1>
    <p>Manage approval-desk accounts and roles.</p>
  </div>
  <a mat-flat-button color="primary" routerLink="/staff/new">
    <mat-icon>person_add</mat-icon>
    New Staff
  </a>
</div>

@if (errorMessage(); as message) {
  <p class="staff-error">{{ message }}</p>
}

@if (loading()) {
  <div class="staff-loading">
    <mat-spinner diameter="32" />
  </div>
} @else {
  <div class="card-surface staff-card">
    @if (staff().length === 0) {
      <div class="staff-empty">
        <mat-icon>group_off</mat-icon>
        <p>No staff accounts yet.</p>
      </div>
    } @else {
      <table mat-table [dataSource]="staff()" class="staff-table">
        <ng-container matColumnDef="display_name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let s">{{ s.display_name }}</td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let s">{{ s.email }}</td>
        </ng-container>

        <ng-container matColumnDef="role">
          <th mat-header-cell *matHeaderCellDef>Role</th>
          <td mat-cell *matCellDef="let s">
            <span class="role-pill" [attr.data-role]="s.role">{{ s.role }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="active">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let s">
            {{ s.active ? 'Active' : 'Inactive' }}{{ s.locked_at ? ' · Locked' : '' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef>Created</th>
          <td mat-cell *matCellDef="let s">{{ s.created_at | date: 'MMM d, y' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let s; columns: columns"></tr>
      </table>
    }
  </div>
}
